// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__12Re9","inner":"Footer_inner__m-Bcr","nextIcon":"Footer_nextIcon__wHXDD","innerLeft":"Footer_innerLeft__5t6cp"};